import React, { memo } from 'react';
import propTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import classNames from 'classnames';
import solventLogoWhite from 'src/ui/assets/solvent-logo-white.svg';
import solventIcon from 'src/ui/assets/solvent-icon.svg';

const Logo = posed.img({
  enter: {
    opacity: 1,
    transition: {
      delay: 250,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    transition: {
      ease: 'easeIn',
      duration: 250,
    },
  },
});

function BankLogo({ logo, logoSmall, bankName, isCondensed }) {
  const bankLogoClassName = classNames('bank-logo', {
    'is-condensed': isCondensed,
  });
  const logoUrl = logo || solventLogoWhite;
  const logoSmallUrl = logoSmall || solventIcon;

  return (
    <figure className={bankLogoClassName}>
      <PoseGroup>
        {!isCondensed && (
          <Logo
            src={logoUrl}
            alt={bankName}
            className="full"
            draggable={false}
            key="full"
          />
        )}
        {isCondensed && (
          <Logo
            src={logoSmallUrl}
            alt={bankName}
            className="small"
            draggable={false}
            key="small"
          />
        )}
      </PoseGroup>
    </figure>
  );
}

BankLogo.defaultProps = {
  bankName: '',
  logo: null,
  logoSmall: null,
};

BankLogo.propTypes = {
  logo: propTypes.string,
  logoSmall: propTypes.string,
  bankName: propTypes.string,
  isCondensed: propTypes.bool.isRequired,
};

const memoizedBankLogo = memo(BankLogo);

export { memoizedBankLogo as BankLogo };
